import React from 'react';

/** Spaces sibling Buttons/ButtonGroups apart as one toolbar row. */
const ButtonToolbar =({ className, children, ...rest }) => (
  <div role="toolbar" className={['ui-btn-toolbar', className].filter(Boolean).join(' ')} {...rest}>
    {children}
  </div>
);

export default ButtonToolbar;
